import BlockPadding from '@/components/block-padding';
import { Quote as QuoteComponent } from '@bumble/ui-kit';

import styles from './quote.module.scss';

export default function Quote({ data }: { data: any }) {
  return (
    <BlockPadding maxWidth="small">
      <div className={styles.inner}>
        <QuoteComponent text={data?.quote} author={data?.author} />
      </div>
    </BlockPadding>
  );
}
